function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef, useState } from 'react';
import { ListItemIcon, ListItemText } from '@material-ui/core';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import BaseButton from './BaseButton';
const SplitButton = ({
  options,
  disabled,
  size = 'medium'
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleMenuItemClick = (event, index, callback) => {
    callback && callback(event);
    setSelectedIndex(index);
    setOpen(false);
  };
  const handleToggle = () => setOpen(prevOpen => !prevOpen);
  const handleClose = event => {
    if (anchorRef.current?.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    variant: "contained",
    color: "primary",
    size: size,
    ref: anchorRef,
    "aria-label": "split button"
  }, /*#__PURE__*/React.createElement(BaseButton, {
    disabled: disabled,
    xs: 12,
    justifyContent: "start",
    textTransform: "unset",
    onClick: options[selectedIndex].onClick
  }, options[selectedIndex].label), /*#__PURE__*/React.createElement(BaseButton, {
    xs: 2,
    color: "primary",
    "aria-controls": open ? 'split-button-menu' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "select merge strategy",
    "aria-haspopup": "menu",
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement(ArrowDropDownIcon, null))), /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: false,
    style: {
      zIndex: 9999
    },
    modifiers: {
      preventOverflow: {
        enabled: true,
        boundariesElement: 'window'
      }
    }
  }, ({
    TransitionProps,
    placement
  }) => /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
    style: {
      transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
    }
  }), /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement(MenuList, {
    id: "split-button-menu"
  }, options.map((option, index) => /*#__PURE__*/React.createElement(MenuItem, {
    disabled: option.disabled,
    key: option.label,
    onClick: event => handleMenuItemClick(event, index, option.onClick)
  }, /*#__PURE__*/React.createElement(ListItemIcon, null, option?.icon), /*#__PURE__*/React.createElement(ListItemText, null, option?.label)))))))));
};
export default SplitButton;